import { commonApi } from '@common/utils/baseQuery';
import config from '@config';
import {
  ICampaignCouponsParticipantsResponse,
  ICampaignParticipants,
  ICampaigns,
} from '@features/campaigns/api/campaignsApi.type';
import { getUnixTime } from 'date-fns';

export const campaignsApi = commonApi.injectEndpoints({
  endpoints: (build) => ({
    fetchCampaigns: build.query<ICampaigns, void>({
      query: () => '/campaigns',
    }),
    fetchCampaignById: build.query<void, { id: number, lang?: string, refill?: boolean }>({
      query: ({ id, lang = 'ru', refill = false }) => ({
        url: `${config.cdn}/${refill ? 'campaignsRefill' : 'campaigns'}/${lang}/${id}.html`,
        params: {
          v: getUnixTime(Date.now()),
        },
        responseHandler: (response) => response.text(),
      }),
      extraOptions: { useToken: false },
    }),
    fetchCampaignParticipants: build.query<ICampaignParticipants, { online?: boolean, campaignId: number, }>({
      query: ({ online, campaignId }) => ({
        url: `/campaigns/top${online ? '/online' : ''}`,
        params: {
          campaignId,
        },
      }),
    }),
    fetchCampaignCouponsParticipants: build.query<ICampaignCouponsParticipantsResponse, { coupon: string, page?: number, limit?: number  }>({
      query: ({ coupon, page, limit = 15 }) => ({
        url: `/campaigns/coupons`,
        params: {
          coupon,
          page,
          limit
        },
      }),
    }),
    promoLinkClick: build.mutation<{ clickId: string; promoCode: string; landing: string; joined: boolean }, { link: string; visitor?: string }>({
      query: (body) => ({
        url: '/promocrm/clicks',
        body,
        method: 'POST',
      }),
      transformResponse: (response: { data?: { clickId: string; promoCode: string; landing: string; joined: boolean } } & { clickId: string; promoCode: string; landing: string; joined: boolean }) => response.data ?? response,
    }),
    leadCampaigns: build.mutation<void, string>({
      query: (code) => ({
        url: '/leadcampaigns',
        body: { code },
        method: 'POST',
      }),
    }),
    fetchCampaignsRefill: build.query<ICampaigns, void>({
      query: () => '/campaigns/online',
    }),
  }),
});

export const {
  useFetchCampaignsQuery,
  useFetchCampaignByIdQuery,
  useFetchCampaignParticipantsQuery,
  useFetchCampaignsRefillQuery,
  useFetchCampaignCouponsParticipantsQuery,
} = campaignsApi;
